import './App.css';
import { ConfigProvider } from 'antd';
import SVGtoJPEGResizer from './SVGtoJPEGResizer';
import { antdLocale } from './i18n';

function App() {
  return (
    <ConfigProvider locale={antdLocale}>
      <div className="App">
        <SVGtoJPEGResizer />
      </div>
    </ConfigProvider>
  );
}

export default App;
